import MultiSelectDropdown from "./MultiSelectDropdown";
import './multiSelectDropdown.scss';

export default MultiSelectDropdown;